// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"3ecfe256","453":"b3d9d97a"}[chunkId] + ".chunk.js";
};